import React, { useEffect, useState } from "react";
import { message } from "antd";
import { Carousel } from 'antd';
import { adminAddCarousel, adminAddYoutubeLink, deleteCarousel, getCarousel, getYoutubeVideo } from "../services/Api";

const AddCarousel = () => {
    const [images, setImages] = useState(Array(4).fill(null));
    const [apiImages, setApiImages] = useState(Array(4).fill(null));
    const [carouselImage, setCarouselImage] = useState([])
    const [youtubeLink, setYoutubeLink] = useState('')
    // console.log(apiImages)
    // console.log(images)
    // console.log(carouselImage)
    const handleImageChange = (file, index) => {
        if (!file || !(file instanceof Blob)) {
            message.error("File not selected.");
            return;
        }

        const reader = new FileReader();
        reader.onload = (e) => {
            const img = new Image();
            img.onload = () => {
                // if (img.width === 417 && img.height === 178) {
                const uploadImages = [...apiImages];
                uploadImages[index] = file;
                setApiImages(uploadImages);

                const updatedImages = [...images];
                updatedImages[index] = URL.createObjectURL(file);
                setImages(updatedImages);
                // } else {
                //     message.error("The image dimensions must be 417x178.");
                // }
            };
            img.src = e.target.result;
        };

        reader.readAsDataURL(file);
    };

    const handleAddCarousel = (status) => {
        const changedImages = apiImages.filter(img => img instanceof File);

        if (status === 'save') {
            if (changedImages.length === 4) {
                adminAddCarousel(changedImages)
                    .then(() => {
                        message.success("Carousel saved");
                        handleGetCarousel();
                    });
            } else {
                message.error("Please select all images");
            }
        }
        else if (status === 'update') {
            if (changedImages.length > 0) {
                adminAddCarousel(changedImages)
                    .then(() => {
                        message.success("Carousel updated");
                        handleGetCarousel();
                    });
            } else {
                message.error("Please select at least one new image");
            }
        }
    };


    const handleGetCarousel = () => {
        getCarousel()
            .then((res) => {
                // console.log("get carousel api response", res)
                setCarouselImage(res.data.data)
                if (res?.data?.data) {
                    const images = res.data.data.map(item =>
                        item.carousel_image.replace(/\\/g, "/")
                    );

                    setApiImages(images);
                }
            })
            .catch((err) => {
                console.error("get carousel api error", err)
            })
    }

    useEffect(() => {
        handleGetCarousel()
    }, [])

    const handleDeleteCarousel = (id) => {
        deleteCarousel(id)
            .then((res) => {
                // console.log("get carousel api response", res)
                message.success(res.data.message)
                handleGetCarousel()
            })
            .catch((err) => {
                console.error("get carousel api error", err)
            })
    }
    const handleAddVideo = () => {
        adminAddYoutubeLink(youtubeLink)
            .then(() => {
                message.success("Video Link saved");
                handleGetCarousel();
            })
            .catch((err) => {
                console.log(err)
            })
    };


    const handleGetYoutubeVideo = () => {
        getYoutubeVideo()
            .then((res) => {
                console.log("get youtube video api response", res.data.data)
                setYoutubeLink(res?.data?.data)
            })
            .catch((err) => {
                console.error("get carousel api error", err)
            })
    }

    useEffect(() => {
        handleGetYoutubeVideo()
    }, [])

    return (
        <>
            <div className=" space-y-6 px-5 py-5">
                <div className="block sm:flex justify-between">
                    <p className="text-base md:text-xl lg:text-2xl text-[#3A4352] font-semibold"> Add Carousel</p>
                </div>
                <div className="block md:flex w-full h-auto ">
                    <div className="w-full md:w-1/2 ">
                        <div className="w-full space-y-6">
                            {[1, 2, 3, 4].map((num, index) => (
                                <div key={num} className="block sm:flex items-center gap-4">
                                    <span className="w-20 text-[16px]">Image {num}:</span>
                                    <div className="w-full md:w-3/4 flex items-center h-10 rounded-md border border-[#B5B5B5] bg-[#FBFBFB] ps-3 pe-1 py-2">
                                        <div className="flex-1 truncate text-xs">
                                            {apiImages[index]?.name ? apiImages[index]?.name : "Choose Image"}
                                        </div>
                                        <label
                                            htmlFor={`upload-${index}`}
                                            className="flex items-center gap-2 bg-black text-white text-[14px] py-1 px-3 rounded-md cursor-pointer active:scale-95"
                                        >
                                            Upload File
                                            <input
                                                id={`upload-${index}`}
                                                type="file"
                                                accept="image/*"
                                                style={{ display: "none" }}
                                                onChange={(e) => handleImageChange(e.target.files[0], index)}
                                            />
                                        </label>
                                    </div>
                                </div>
                            ))}
                            <p className="text-[16px] text-black mt-4">
                                Note: <span className="font-bold">Image size should be 417x178</span>
                            </p>
                        </div>
                    </div>
                    <div className="w-full md:w-1/2 px-5 md:px-10">
                        <div className="w-full ">
                            <p className="mt-5 text-lg" >Preview :</p>
                            {carouselImage.length > 0 &&
                                <Carousel autoplay autoplaySpeed={2000} dots={false} className="rounded-3xl mt-3">
                                    {carouselImage.map((image, index) =>
                                        image ? (
                                            <div className="relative" key={index}>
                                                <img alt={`carousel-image-${index}`} src={process.env.REACT_APP_API_URL + image.carousel_image} className="rounded-2xl w-full max-h-48 min-h-48" />
                                                <div className=" absolute top-2 right-5 bg-gray-700 shadow-lg rounded-full w-fit h-fit flex justify-center items-center px-2">
                                                    <p className="  text-white font-semibold text-xl"> {index + 1} </p>
                                                </div>
                                                <div className=" absolute top-2 left-5 bg-gray-700 shadow-lg rounded-full w-fit h-fit flex justify-center items-center px-2">
                                                    <button onClick={() => handleDeleteCarousel(image?._id)} className="  text-white font-semibold text-xl"> X </button>
                                                </div>
                                            </div>
                                        ) : null
                                    )}
                                </Carousel>
                            }
                            <div className="">
                                {/* <div className=" flex justify-end mt-5">
                                <button className=" w-1/2 rounded-lg px-3 py-2 flex bg-[#E53935] text-white text-xs justify-center items-center active:scale-95" onClick={handleRefresh}> <img alt="refresh-icon" className="h-5 me-1" src={Refresh} /> Delete</button>
                            </div> */}
                                {carouselImage.length > 0 ?
                                    <div className=" flex justify-end mt-5 ">
                                        <button className=" w-1/2 rounded-lg py-2 bg-[#008400] text-white text-xs text-center active:scale-95" onClick={() => handleAddCarousel('update')}>Update</button>
                                    </div>
                                    :
                                    <div className=" flex justify-end mt-5 ">
                                        <button className=" w-1/2 rounded-lg py-2 bg-[#008400] text-white text-xs text-center active:scale-95" onClick={() => handleAddCarousel('save')}>Save</button>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>

                </div>

                <div className="block sm:flex justify-between">
                    <p className="text-base md:text-xl lg:text-2xl text-[#3A4352] font-semibold"> Add Video Link</p>
                </div>
                {/* <div className="block md:flex w-full h-auto ">
                    <span className="w-40 text-[16px]">Video Link</span>
                    <div className="w-full md:w-3/4 ">
                        <div className="w-full space-y-6">
                            <input
                                value={youtubeLink}
                                onChange={(e) => setYoutubeLink(e.target.value)}
                                placeholder="Enter youtube video Link"
                                className="w-full md:w-3/4 flex items-center h-10 rounded-md border border-[#B5B5B5] bg-[#FBFBFB] ps-3 pe-1 py-2 outline-none focus:outline-none"
                            />
                        </div>
                    </div>
                    <div className="w-full md:w-1/2 px-5 md:px-10">
                        <div className="w-full ">
                            <p className=" text-lg" >Preview :</p>

                            <div className="">
                                {carouselImage.length > 0 ?
                                    <div className=" flex justify-end mt-5 ">
                                        <button className=" w-1/2 rounded-lg py-2 bg-[#008400] text-white text-xs text-center active:scale-95" onClick={() => handleAddCarousel('update')}>Update</button>
                                    </div>
                                    :
                                    <div className=" flex justify-end mt-5 ">
                                        <button className=" w-1/2 rounded-lg py-2 bg-[#008400] text-white text-xs text-center active:scale-95" onClick={() => handleAddCarousel('save')}>Save</button>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>

                </div> */}

                <div className="block md:flex w-full h-auto ">
                    <div className="w-full md:w-1/2 ">
                        <div className="w-full space-y-6">
                            <div className="block sm:flex items-center gap-4">
                                <span className="w-20 text-[16px]">Link</span>
                                <div className="w-full md:w-3/4 ">
                                    <input
                                        value={youtubeLink}
                                        onChange={(e) => setYoutubeLink(e.target.value)}
                                        placeholder="Enter youtube video Link"
                                        className="w-full flex items-center h-10 rounded-md border border-[#B5B5B5] bg-[#FBFBFB] ps-3 pe-1 py-2 outline-none focus:outline-none"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="w-full md:w-1/2 px-5 md:px-10">
                        <div className="w-full ">
                            <p className=" text-lg" >Preview :</p>
                            <div className='h-full'>
                                <div style={{ position: 'relative', paddingBottom: '70%', height: 0 }}>
                                    <iframe
                                        src={youtubeLink}
                                        title="YouTube video"
                                        className="absolute top-0 left-0 w-full h-full rounded-4xl"
                                        allow="autoplay; encrypted-media"
                                        allowFullScreen
                                    />
                                </div>
                            </div>
                            <div className="">
                                <div className=" flex justify-end mt-5 ">
                                    <button className=" w-1/2 rounded-lg py-2 bg-[#008400] text-white text-xs text-center active:scale-95" onClick={() => handleAddVideo()}>Add Video</button>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            </div>
        </>
    )
}
export default AddCarousel;